/*global Stripe*/

export default {
  init() {

    if(!$('#subscribe-form').length) {
      return;
    }

    var stripe = Stripe($('#subscribe-form').data('stripe-key'));

    var elements = stripe.elements(),
        card = elements.create('card', {
                iconStyle: 'solid',
                hidePostalCode: true,
                style: {
                  base: {
                    iconColor: '#37393A',
                    color: '#37393A',
                    fontWeight: 500,
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSize: '16px',
                    fontSmoothing: 'antialiased',
                  },
                  invalid: {
                    iconColor: '#BD302A',
                    color: '#BD302A',
                  },
                },
              });

    card.mount('#card-element');


    $('#subscribe-form').on('initSubscribeForm', function(){

      var el = $(this);

      $('.input-radio.type-radio', el).on('ifChanged', function (e) {

        if(e.target.checked != true) {
          return
        }

        if($(e.target).val() == 'gift' || $(e.target).val() == 'gift-renewal') {
          $(el).addClass('gift-selected');
        } else {
          $(el).removeClass('gift-selected');
        }

      });



      $('.input-text, .input-select', el).trigger('blur');

      var buttonEl = $(el).find('.submit'),
          messageEl = $(el).find('.description');

      // Store message's current text as the default text
      $(messageEl).data('default-text', $(messageEl).text());
      $(buttonEl).data('default-label', $(buttonEl).text());

      $('input, .customSelect, textarea', el).on('focus', function(){

        var message = $(messageEl).data('default-text'),
            label    = $(buttonEl).data('default-label');

          if(!message.length) {
            message = '';
          }

          if(!label.length) {
            label = 'Subscribe';
          }

        $(buttonEl).removeAttr('disabled').text(label);
        $(el).removeClass('with-errors').removeClass('with-success');

      });


    }).on('submit', function(e){

      e.preventDefault();

      var el = $(this),
          tokenEl = $('input[name*="card_token"]', el);


      if($(el).hasClass('is-sending')) {
        return;
      }

      $(el).trigger('disableForm').removeClass('with-errors');

      stripe.createToken(card).then(function(result) {
        if (result.error) {
          // Inform the user if there was an error.
  //           var errorElement = document.getElementById('card-errors');
  //           errorElement.textContent = result.error.message;
  //         console.log('ERROR: '+result.error.message);
          $(el).trigger('showErrors', result.error.message);

        } else {
          // Send the token to your server.
          //stripeTokenHandler(result.token);
  //         console.log('token', result.token.id);

          $(tokenEl).val(result.token.id);
          //$(el).get(0).submit();
          $(el).trigger('sendForm');
        }

      });


    })

    .on('disableForm', function(){

      var el = $(this),
          buttonEl = $(el).find('.submit');

      $(buttonEl).attr('disabled','disabled').text('Sending...');
      $(el).addClass('is-sending').removeClass('with-success').removeClass('with-errors');

    })

    .on('showSuccess', function(e, successMessage){ // eslint-disable-line

      var el = $(this),
          buttonEl = $(el).find('.submit'),
          messageEl = $(el).find('.description'), // eslint-disable-line
          cancelButton = $(el).find('.cancel');

      $(buttonEl).removeAttr('disabled');

      $(el).trigger('enableForm').removeClass('with-errors').addClass('with-success');
      $(buttonEl).text('Success');
      $(cancelButton).text('Done');


      // Reset Data
      $(el)[0].reset();

    })

    .on('sendForm', function(){

      var el         = $(this),
          dataSource = $(el).attr('action'),
          thankYouURL= $(el).data('thank-you-page');

  //     console.log('THANK YOU: ', buttonEl, 'Loading '+dataSource+'...');

      $(el).trigger('disableForm').removeClass('with-errors');

      var formData = jQuery(el).serialize();

  //     console.log(formData);

      $.ajax({
          url: dataSource,
          type: 'POST',
          data:formData,
          success: function(data){

  //           console.log(data);

  //               $(el).trigger('enableForm');

            if (typeof data === 'undefined') {
              setTimeout(function() {
                $(el).trigger('showErrors', 'An error occured');
                $(window).trigger('resize');
              }, 500);
              return;
            }

            setTimeout(function() {

              var methodToTrigger = (data.success) ? 'showSuccess' : 'showErrors';
              $(el).trigger(methodToTrigger, data.message);

              if (data.success && (typeof thankYouURL !== 'undefined') && thankYouURL.length) {
                setTimeout(function() {
                  window.location.replace(thankYouURL);
                }, 1000);
              }

            }, 500);

          }, error: function() {

          setTimeout(function() {
            $(el).trigger('showErrors', 'An error occured');
          }, 500);

        },

      });

    })

    .on('showErrors', function(e, errorMessage){
      console.info('showErrors', errorMessage,e);
      var el = $(this),
          buttonEl = $(el).find('.submit'),
          messageEl = $(el).find('.description');

      $(el).removeClass('is-sending').removeClass('with-success').addClass('with-errors');

      setTimeout(function() {
        $(buttonEl).removeAttr('disabled').text('Errors Found');
        $(messageEl).text(errorMessage);
      }, 250);

    })

    .on('enableForm', function(){

      var el = $(this),
          buttonEl = $(el).find('.submit'),
          label = $(buttonEl).data('default-label');

        if (typeof label === 'undefined' || !label.length) {
          label = 'Submit';
        }

      $(buttonEl).removeAttr('disabled').text(label);
      $(el).removeClass('is-sending');

    })

    .on('resetForm', function(){

      var el = $(this),
          buttonEl = $(el).find('.submit'),
          messageEl = $(el).find('.description'),
          label = $(buttonEl).data('default-label'),
          message = $(messageEl).data('default-text');

        if (typeof label === 'undefined' || !label.length) {
          label = 'Submit';
        }

      $(el)[0].reset();

      $(buttonEl).removeAttr('disabled').text(label);
      $(messageEl).text(message);
      $(el).removeClass('is-sending').removeClass('with-errors').removeClass('with-success');

    }).trigger('initSubscribeForm');



  },
};



// WEBPACK FOOTER //
// ./scripts/routes/subscribe.js